import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { AutomationRulesService } from '@app/features/automation-rules/automation-rules.service';
import {
  findActionByNameAndValue,
  findConditionByNameAndValue,
  RulesActions,
  RulesAmountType,
  RulesAutomationValidationStatuses,
  RulesConditions,
  RulesOperator,
  RulesTag,
  handleColorCodingBackdropClick,
} from '@app/features/automation-rules/utils';
import { initShopTimeZone } from '@app/pages/checkout-app/utils';
import { Shop } from '@app/services/shops/shop.model';
import { ShopService } from '@app/services/shops/shop.service';
import { DropdownOption } from '@app/storybook/components/dropdown/dropdown.component';
import {
  DeliveryMethodType,
  FilterEntities,
  SkusResponseType,
  TagResponseType,
} from '@pages/workspace/assign/components/advanced-filters/config/models';
import { ServiceLevelToDisplayName } from '@pdqdev/pdq-shared/dist/CarrierData';
import { ColorCoding, ColorEnum, OrderStatus } from '@pdqdev/pdq-shared/dist/entities';
import { CountryCode, getCountryDisplayNameByCountryCode } from '@pdqdev/pdq-shared/dist/utils/Country-utils';
import { of, Subject, Subscription } from 'rxjs';
import { catchError, debounceTime, finalize, first, switchMap, takeUntil, tap } from 'rxjs/operators';
import { currencyStrToSign, generateTimeOptions } from 'src/utils';
import { AutomationRulesActions } from '../../../actions';
import { SelectedRuleParams } from '../rule-template-selector.component';
import { RuleTemplateService } from '../rule-template.service';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'order-created-template',
  templateUrl: './order-created-template.component.html',
  styleUrls: ['./order-created-template.component.scss'],
  standalone: false,
})
export class OrderCreatedTemplateComponent implements AfterViewInit, OnInit, OnDestroy {
  @Input() conditions: Array<any>;
  @Input() actions: Array<any>;
  @Input() selectedRuleParams?: SelectedRuleParams;
  @Input() notVerifiedName: string;

  @Input() onChangeConditionSelect: EventEmitter<any>;
  @Input() onChangeActionSelect: EventEmitter<any>;
  @Input() onChangeOperatorSelect: EventEmitter<any>;
  @Input() onChangeOperator2Select: EventEmitter<any>;
  @Input() onRemoveCondition: EventEmitter<any>;
  @Input() onChangeNotVerifiedName: EventEmitter<any>;
  @ViewChildren('conditionSelect') conditionSelects: QueryList<MatSelect>;
  @ViewChildren('selectList') selectList;
  @ViewChildren('selectOrList') selectOrList;
  @ViewChildren('tagsInput') tagsInputs;
  @ViewChildren('skusInput') skusInputs;
  @ViewChildren('deliveryMethodInput') deliveryMethodInput;

  readonly RulesAmountType = RulesAmountType;
  verfiedNameToReset: string;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private automationRulesService: AutomationRulesService,
    private ruleTemplateService: RuleTemplateService,
    private shopService: ShopService,
  ) {}

  detroyed$ = new Subject();
  isLoadingResults: boolean = false;
  indexOfLastMatOption: any = null;
  tagsControlsSubscriptions$: Subscription[] = [];
  skusControlsSubscriptions$: Subscription[] = [];
  deliveryMethodsControlsSubscriptions$: Subscription[] = [];
  inventoryLocationOptions: DropdownOption[];
  inventoryLocationActionOptions: DropdownOption[];
  splitMethodOptions: DropdownOption[];
  isProviderEqualToCarrier: boolean = false;
  packagesOptions: DropdownOption[][][] = [[[null]]];
  statusOptions: DropdownOption[][][] = [[[null]]];
  deliveryMethodOptions: DropdownOption[][][] = [[[null]]];
  paymentStatusOptions: DropdownOption[][][] = [[[null]]];
  headsUp = [];
  autocompleteSplitMethods = ['product_tag'];
  shopTimeZone: string;
  autoCompleteCache = new Map<string, TagResponseType | SkusResponseType | DeliveryMethodType>();
  handleColorCodingBackdropClick = handleColorCodingBackdropClick;

  // ---Conditions---
  currentConditionsSelectValue: AutomationRulesActions.SelectedCondition[] = [null];

  currentAllConditionsSelectValue: AutomationRulesActions.SelectedCondition[][] = [[null]];
  currentOperatorValue: RulesOperator[][] = [[null]];
  currentOperator2Value: RulesOperator[][] = [[null]];
  currentCountrySelectValue: Array<Array<string | null>> = [[null]];
  currentStateSelectValue: Array<Array<string | null>> = [[null]];
  currentDeliveryMethodsSelectValue: Array<Array<string | null>> = [[null]];
  controls = [[new UntypedFormControl()]];
  setWeightToSKUInputControl = new UntypedFormControl();
  tags: RulesTag[] = [];
  currentSelectedTags: RulesTag[][][] = [[[]]];
  splitOrderData;

  skus: string[] = [];
  deliveryMethods = [];

  currentSelectedSkus: string[][][] = [[[]]];
  currentSelectedDeliveryMethods: string[][][] = [[[]]];
  currentWeightValue: number[][] = [[null]];
  currentTotalValueVal: number[][] = [[]];
  currentItemQuantityValue: number[][] = [[null]];
  currentInventoryLocationValue: DropdownOption[][] = [[null]];
  currentPackageValue: DropdownOption[][][] = [[[]]];
  currentStatusValue: DropdownOption[][][] = [[[]]];
  currentPaymentStatusValue: DropdownOption[][][] = [[[]]];
  currentTagsValue: Array<string>[] = [[]];
  currentSkusValue: Array<string>[] = [[]];
  currentCreatedOnValue: Array<
    Array<{
      weekDays: DropdownOption[];
      from: DropdownOption;
      to: DropdownOption;
      timezone: string;
    }>
  > = [[null]];
  currentTimeWindowValue: Array<
    Array<{
      weekDays: DropdownOption[];
      from: DropdownOption;
      to: DropdownOption;
      timezone: string;
    }>
  > = [[null]];
  // ---Actions---
  currentActionSelectValue: AutomationRulesActions.SelectedAction;
  currentDeliveryServiceSelectValue: DropdownOption;
  currentShippingDays: number;
  currentLocationActionValue: DropdownOption;
  currentEmailSelectValue: Array<string>;
  currentShipmentExtras: any = {};
  currentTeamNote: any = {};
  currentDelayTime: number = 0;
  shopSettings: any = {};
  deliveryMethod = '';
  currentColorCoding: string[] = [ColorEnum.NO_COLOR];
  currentColorCodingOperator: DropdownOption;
  currentSplitMethod: DropdownOption;
  currentSplitMethodOperator: DropdownOption;
  currentSplitMethodOperator2: DropdownOption;
  splitOrderActionFreeText: string;
  isProductTagsSplitOnAutocompleteMode: boolean;
  currentProductTagsSplitOperator: DropdownOption;
  currentShipOnValue: any = {};
  currentActionTagsValue: string[] = [];
  currentRecommendedCarrier: any = {};
  deliveryDateOptions: DropdownOption[][] = [null];
  colorCodingOptions: DropdownOption[] = [];
  createdWeekDaysOptions: DropdownOption[][][] = [[[null]]];
  timeWindowWeekDaysOptions: DropdownOption[][][] = [[[null]]];
  timeWindowOfDayOptions = generateTimeOptions();
  timeOfDayOptions = generateTimeOptions();
  carriersData;
  colorCodingData: ColorCoding[];
  loadingDeliveryMethods: boolean = false;
  deliveryMethodAutoCompleteOptions;
  currentSetWeightToSKUValue: any;
  currentDeliveryMethodValue: string[][] = [[null]];
  currentDeliveryMethodInputValue: string[][] = [[null]];

  ngOnInit() {
    this.initDropDownOptions();
    this.initListeners();
    this.initSelectedRuleParams();
    this.initShopSettings();
    this.initSearchTerm([0, 0], FilterEntities.TAG);
    this.initSearchTerm([0, 0], FilterEntities.DELIVERY_METHOD);
    this.initSearchTerm([0, 0], FilterEntities.SKU);
    this.verfiedNameToReset = this.notVerifiedName;
  }

  ngAfterViewInit() {
    this.selectOrList.changes.subscribe((newList) => {
      this.conditionSelects.forEach((condition: MatSelect) => {
        if (!this.indexOfLastMatOption) {
          return;
        }
        const [j, i] = this.indexOfLastMatOption;
        const atrb = condition._elementRef.nativeElement.getAttribute('data-2dIndex');
        if (condition._elementRef.nativeElement.getAttribute('data-2dIndex') == j + ',' + i) {
          this.indexOfLastMatOption = null;
          condition.open();
          this.changeDetectorRef.detectChanges();
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.detroyed$.next(true);
  }
  getCountryNameByCode(code: string) {
    if (!code) {
      return;
    }
    return getCountryDisplayNameByCountryCode(code as CountryCode);
  }

  initListeners() {
    this.onChangeActionSelect.pipe(takeUntil(this.detroyed$)).subscribe((e) => this.setHeadsUpNotifications(e));
  }

  initSelectedRuleParams() {
    this.currentAllConditionsSelectValue = this.getSelectedConditions();

    this.currentActionSelectValue = this.getSelectedAction();

    if (!this.currentActionSelectValue) {
      return;
    }

    const selectedAction = { ...this.currentActionSelectValue };
    if (selectedAction.name == RulesActions.ColorCoding && this.currentColorCoding) {
      this.onColorCodingChanged(this.currentColorCoding, this.currentColorCodingOperator);
    } else if (selectedAction.name == RulesActions.SplitOrderByStrategy) {
      const selectedAction = {
        ...this.currentActionSelectValue,
      };
      selectedAction.value = this.splitOrderData;
      this.onChangeActionSelect.emit(selectedAction);
    } else if (this.currentEmailSelectValue) {
      this.selectEmail({
        value: this.currentEmailSelectValue,
      });
    } else if (this.currentDelayTime) {
      this.setChangeOrderStatusWithDelayAction(this.currentDelayTime);
    } else if (this.currentLocationActionValue) {
      this.onChangeLocationSelectedOrder(this.currentLocationActionValue);
    } else if (this.currentShipmentExtras?.shipmentExtrasFields) {
      this.onShipmetExtrasChanged(this.currentShipmentExtras?.shipmentExtrasFields);
    } else if (this.currentTeamNote?.message) {
      this.onTeamNoteChanged(this.currentTeamNote);
    } else if (this.deliveryMethod) {
      this.onDeliveryMethodChanged(this.deliveryMethod);
    } else if (selectedAction.name === RulesActions.SetRecommendedCarrier) {
      this.onShipmentPreferencesChanged(this.currentRecommendedCarrier);
    } else if (selectedAction.name === RulesActions.AddTags) {
      this.tagsChanged(this.currentActionTagsValue);
    } else if (selectedAction.name === RulesActions.SetWeightToSKU) {
      this.initSearchTerm(null, FilterEntities.SKU, this.setWeightToSKUInputControl);
      this.onSetWeightToSKUChanged(this.currentSetWeightToSKUValue?.weight, this.currentSetWeightToSKUValue?.sku);
    } else {
      this.onChangeActionSelect.emit(selectedAction);
    }
  }

  initDropDownOptions() {
    this.inventoryLocationOptions = this.ruleTemplateService.convertValuesToDropDownOptions({
      conditions: this.conditions[0].values,
      conditionName: 'inventoryLocation',
      labelField: 'storeName',
    });

    this.packagesOptions[0][0] = this.ruleTemplateService.initialPackagesOptions(
      this.ruleTemplateService,
      this.conditions,
    );

    this.inventoryLocationActionOptions = this.ruleTemplateService.convertValuesToDropDownOptions({
      conditions: this.actions[0].values,
      conditionName: 'setInventoryLocation',
      labelField: 'storeName',
    });

    this.splitMethodOptions = this.ruleTemplateService.convertValuesToDropDownOptions({
      conditions: this.actions[0].values,
      conditionName: 'splitOrderBy',
      labelField: 'value',
      isRawValues: true,
      displayLabelFunc: (strValue) => strValue?.split('_')?.join(' '),
    });

    this.statusOptions[0][0] = this.ruleTemplateService.convertValuesToDropDownOptions({
      labelField: 'label',
      valueField: 'value',
      typeField: 'type',
      values: RulesAutomationValidationStatuses,
      multiSelect: true,
    });
    this.deliveryMethodOptions[0][0] = this.ruleTemplateService.convertValuesToDropDownOptions({
      labelField: 'label',
      valueField: 'value',
      typeField: 'type',
      conditionName: 'deliveryMethod',
      conditions: this.conditions[0].values,
      multiSelect: true,
    });
    this.paymentStatusOptions[0][0] = this.ruleTemplateService.convertValuesToDropDownOptions({
      labelField: 'label',
      valueField: 'value',
      typeField: 'type',
      conditionName: 'paymentStatus',
      conditions: this.conditions[0].values,
      multiSelect: true,
    });
    this.colorCodingOptions = this.ruleTemplateService.convertValuesToDropDownOptions({
      conditions: this.actions[0].values,
      conditionName: 'setColorCoding',
      labelField: 'label',
      valueField: 'value',
    });
    this.currentColorCodingOperator = this.colorCodingOptions[0];
    this.createdWeekDaysOptions[0][0] = this.ruleTemplateService.initCreatedOnOptions(this.conditions);
    this.timeWindowWeekDaysOptions[0][0] = this.ruleTemplateService.initTimeWindowWeekDaysOptions(this.conditions);
  }

  initSearchTerm(index: any, type: FilterEntities, control: UntypedFormControl = null): void {
    let fieldName;
    switch (type) {
      case FilterEntities.TAG:
        fieldName = 'tags';
        break;
      case FilterEntities.SKU:
        fieldName = 'skus';
        break;
      case FilterEntities.DELIVERY_METHOD:
        fieldName = 'deliveryMethods';
        break;
      default:
        fieldName = 'tags';
    }
    if (index !== null && !control) {
      const [j, i] = index;
      control = this.controls[j][i];
    }
    this[fieldName] = [];
    let subscription;
    const autoCompleteRes$ = control.valueChanges.pipe(
      debounceTime(500),
      tap(() => (this.isLoadingResults = true)),

      switchMap((value) => {
        const trimmedValue = value?.trim();
        if (trimmedValue?.length > 0) {
          {
            if (this.autoCompleteCache.has(trimmedValue + '_' + type)) {
              this.isLoadingResults = false;
              return of(this.autoCompleteCache.get(trimmedValue + '_' + type));
            }
          }

          return this.automationRulesService.getAutoComplete(trimmedValue, type).pipe(
            tap((response) => {
              this.isLoadingResults = false;
              this.autoCompleteCache.set(trimmedValue + '_' + type, response);
            }),
            catchError((error) => {
              return of([]);
            }),
          );
        } else {
          this[fieldName] = [];
          this.isLoadingResults = false;
          this.changeDetectorRef.detectChanges();
          return [];
        }
      }),
      finalize(() => {
        this.isLoadingResults = false;
        this.changeDetectorRef.detectChanges();
      }),
    );
    switch (type) {
      case FilterEntities.TAG:
        this.processTagAutocomplete(autoCompleteRes$);
        break;
      case FilterEntities.SKU:
        this.processSkuAutocomplete(autoCompleteRes$);
        break;
      case FilterEntities.DELIVERY_METHOD:
        this.processDeliveryMethodAutocomplete(autoCompleteRes$);
        break;
    }
  }

  private processDeliveryMethodAutocomplete(res$) {
    const subscription = res$.subscribe((res: DeliveryMethodType) => {
      this.deliveryMethods = res;
    });

    this.deliveryMethodsControlsSubscriptions$.push(subscription);
  }

  private processSkuAutocomplete(res$) {
    const subscription = res$.subscribe((res: TagResponseType | SkusResponseType) => {
      this.skus = (res as SkusResponseType).skus;
    });
    this.skusControlsSubscriptions$.push(subscription);
  }

  private processTagAutocomplete(res$) {
    const subscription = res$.subscribe((res: TagResponseType | SkusResponseType) => {
      this.tags = (res as TagResponseType).orderTags
        .map((tag) => ({
          name: tag.name,
          type: 'tableOrderTag',
        }))
        .concat(
          (res as TagResponseType).productTags.map((tag) => ({
            name: tag.name,
            type: 'tableProductTag',
          })),
        );
    });
    this.tagsControlsSubscriptions$.push(subscription);
  }

  initShopSettings() {
    this.shopService.shop$.pipe(first()).subscribe((shop: Shop) => {
      this.shopSettings = {
        shopTimeZone: initShopTimeZone(shop),
        currency: currencyStrToSign(shop.metadata?.currency),
        weightUnits: shop.metadata?.weightUnits,
      };
      this.shopTimeZone = shop.metadata?.ianaTimeZone;
      this.colorCodingData = shop.colorCoding;
    });
  }

  getSelectedConditions() {
    if (!this.selectedRuleParams) {
      return [[null]];
    }
    const j = 0;
    const selectedConditions = [[]];
    const orWhenLength = this.selectedRuleParams.orWhen.length;
    for (let j = 0; j < orWhenLength; j++) {
      this.addOrCondition(j, false);
      for (let i = 0; i < this.selectedRuleParams.orWhen[j].andWhen.length; i++) {
        this.addCondition([j, i], false);
        const andWhenName: string = Object.keys(this.selectedRuleParams.orWhen[j].andWhen[i])?.pop();
        const andWhenValue: any = Object.values(this.selectedRuleParams.orWhen[j].andWhen[i])?.pop();
        const andWhenValueToCheck = andWhenValue.values ? andWhenValue.values : andWhenValue;
        const condition = this.conditions[0].values.find(
          findConditionByNameAndValue.bind(null, andWhenName, andWhenValueToCheck),
        );
        if (!selectedConditions[j]) {
          selectedConditions[j] = [];
        }
        selectedConditions[j].push(condition);
        switch (andWhenName) {
          case 'shippingAddressCountry':
            this.currentCountrySelectValue[j][i] = andWhenValue.countries;
            const operator = andWhenValue.operator
              ? andWhenValue.operator
              : condition.operators.find(
                  (operator: RulesOperator) => operator.value == (andWhenValue.is ? 'is' : 'is-not'),
                );
            //should be transferred to use with "operator" field in place of "is" field, was left with that way to prevent regression
            this.currentOperatorValue[j][i] = operator;
            break;
          case 'shippingAddressState':
            this.currentStateSelectValue[j][i] = andWhenValue.states;
            const stateOperator =
              andWhenValue.operator ?? condition.operators.find((operator: RulesOperator) => operator.value == 'is');
            this.currentOperatorValue[j][i] = stateOperator;
            break;
          case 'deliveryMethod':
            // supports conditions made in old format, as single string
            if (typeof andWhenValue !== 'object') {
              const selectedOption = (this.deliveryMethodOptions as any[]).find((opt) => opt.value === andWhenValue);
              const operator = condition.operators.find((operator: RulesOperator) => operator.value == 'is');
              this.currentOperatorValue[j][i] = operator;
              if (selectedOption) {
                selectedOption.checked = true;
                this.currentDeliveryMethodsSelectValue[j][i] = selectedOption;
                const value = { operator: operator, is: operator.value === 'is', values: [selectedOption] };
                this.onChangeConditionSelect.emit({ value: { ...condition, value: value }, index: [j, i] });
              }
            }
            // current condition format
            else {
              this.currentDeliveryMethodsSelectValue[j][i] = andWhenValue.values.map((val) => ({
                ...val,
                checked: true,
              })); //needed to match storybook dropdown control
              this.currentSelectedDeliveryMethods[j][i] = andWhenValue.values.map((val) => val.value);

              this.currentDeliveryMethodInputValue[j][i] = this.currentSelectedDeliveryMethods[j][i].join(', ');

              const operator = andWhenValue.operator
                ? andWhenValue.operator
                : condition.operators.find((operator: RulesOperator) => operator.value == 'is');
              this.currentOperatorValue[j][i] = operator;
            }
            break;
          case 'orderTag':
            this.currentOperatorValue[j][i] = andWhenValue.operator;
            if (andWhenValue.operator2) {
              this.currentOperator2Value[j][i] = andWhenValue.operator2;
            }
            if (andWhenValue.selectedTags) {
              this.currentSelectedTags[j][i] = andWhenValue.selectedTags;
            }
            if (andWhenValue.value) {
              this.currentTagsValue[j][i] = andWhenValue.value;
            }
            break;
          case 'orderSku':
            this.currentOperatorValue[j][i] = andWhenValue.operator;
            if (andWhenValue.operator2) {
              this.currentOperator2Value[j][i] = andWhenValue.operator2;
            }
            if (andWhenValue.selectedSkus) {
              this.currentSelectedSkus[j][i] = andWhenValue.selectedSkus;
            }
            if (andWhenValue.value) {
              this.currentSkusValue[j][i] = andWhenValue.value;
            }
            break;
          case 'totalOrderWeight':
            this.currentWeightValue[j][i] = andWhenValue.amount;
            this.currentOperatorValue[j][i] = andWhenValue.operator;
            break;
          case 'totalOrderValue':
            this.currentTotalValueVal[j][i] = andWhenValue.amount;
            this.currentOperatorValue[j][i] = andWhenValue.operator;
            break;
          case 'itemQuantity':
            this.currentItemQuantityValue[j][i] = andWhenValue.amount;
            this.currentOperatorValue[j][i] = andWhenValue.operator;
            break;
          case 'inventoryLocation':
            this.currentInventoryLocationValue[j][i] = andWhenValue.address;
            this.currentOperatorValue[j][i] = andWhenValue.operator;
            break;
          case 'boxChosen':
            this.currentPackageValue[j][i] = andWhenValue.boxesArray;
            this.currentOperatorValue[j][i] = andWhenValue.operator;
            break;
          case 'orderStatusFix':
            this.currentStatusValue[j][i] = andWhenValue.statusArray;
            break;
          case 'paymentStatus':
            this.currentPaymentStatusValue[j][i] = andWhenValue.statuses || [];
            this.onChangeConditionSelect.emit({ value: { ...condition, value: andWhenValue }, index: [j, i] });
          case RulesConditions.CreatedOn:
            this.currentCreatedOnValue[j][i] = andWhenValue;
            break;
          case RulesConditions.Time:
            this.currentTimeWindowValue[j][i] = andWhenValue;
            this.currentOperatorValue[j][i] = andWhenValue.operator;
            break;
        }
        this.controls[j][i] = new UntypedFormControl();
        this.initSearchTerm([j, i], FilterEntities.TAG);
        this.initSearchTerm([j, i], FilterEntities.SKU);
        this.initSearchTerm([j, i], FilterEntities.DELIVERY_METHOD);
      }
    }
    return selectedConditions;
  }

  getSelectedAction() {
    if (!this.selectedRuleParams) {
      return null;
    }
    const selectedActionName: any = Object.keys(this.selectedRuleParams.andThen[0])[0];
    const selectedActionValue: any = Object.values(this.selectedRuleParams.andThen[0])[0];

    switch (selectedActionName) {
      case RulesActions.SendEmail:
        this.currentEmailSelectValue = selectedActionValue;
        break;
      case RulesActions.ChangeStatusWithDelay:
        this.currentDelayTime = selectedActionValue.delayTime;
        break;
      case RulesActions.SetRecommendedCarrier:
        this.currentShipOnValue = selectedActionValue.shipOn?.shipOn ? selectedActionValue.shipOn : {};
        this.currentRecommendedCarrier = selectedActionValue.shipmentPreferncesFields;
        const actionData = this.actions[0]?.values?.find((a) => a.name === 'setRecommendedCarrier');
        this.deliveryDateOptions = actionData.shipOnValues?.find((option) => option.value.includes('Before'))?.values;
        this.carriersData = actionData.values;
        break;
      case RulesActions.SetInventoryLocation:
        this.currentLocationActionValue = this.inventoryLocationActionOptions.find(
          (option) => option?.value == selectedActionValue?.value,
        );
        break;
      case RulesActions.UnifyInventoryLocation:
        this.currentLocationActionValue = this.inventoryLocationActionOptions.find(
          (option) => option?.value == selectedActionValue?.value,
        );
        break;
      case RulesActions.ShipmentExtras:
        this.currentShipmentExtras = selectedActionValue;
        break;
      case RulesActions.TeamNote:
        this.currentTeamNote = selectedActionValue;
        break;
      case RulesActions.DeliveryMethod:
        this.deliveryMethod = selectedActionValue;
        break;
      case RulesActions.ColorCoding:
        this.currentColorCoding = selectedActionValue.colors;
        this.currentColorCodingOperator = selectedActionValue.operator;
        break;
      case RulesActions.SplitOrderByStrategy:
        this.splitOrderData = selectedActionValue;
        break;
      case RulesActions.AddTags:
        this.currentActionTagsValue = selectedActionValue;
        break;
      case RulesActions.SetWeightToSKU:
        this.currentSetWeightToSKUValue = selectedActionValue;
    }

    return this.actions[0].values.find(findActionByNameAndValue.bind(null, selectedActionName, selectedActionValue));
  }

  changeConditionSelect({ value: selectedCondition }, index): void {
    const [j, i] = index;

    const updatedSelectedCondition = { ...selectedCondition };
    this.currentStatusValue[j][i] = null;

    switch (selectedCondition.name) {
      case 'shippingAddressCountry':
        this.currentOperatorValue[j][i] = selectedCondition.operators[0];
        updatedSelectedCondition.value = { operator: this.currentOperatorValue[j][i] };
        break;
      case 'shippingAddressState':
        this.currentOperatorValue[j][i] = selectedCondition.operators[0];
        updatedSelectedCondition.value = { operator: this.currentOperatorValue[j][i] };
        break;
      case 'deliveryMethod':
        this.currentOperatorValue[j][i] = selectedCondition.operators[0];
        updatedSelectedCondition.value = { operator: this.currentOperatorValue[j][i] };
        this.currentDeliveryMethodsSelectValue[j][i] = undefined;
        break;
      case 'orderTag':
        const updatedOrderTagsOperatorOptions = this.ruleTemplateService.prepareOperatorOptions(
          selectedCondition.operators,
          i,
          RulesAmountType.TAGS,
          this.currentAllConditionsSelectValue[j],
          this.currentOperatorValue[j],
        );
        this.currentOperatorValue[j][i] = updatedOrderTagsOperatorOptions.find(
          (option: DropdownOption) => !option.disabled,
        );
        const updatedOrderTagsOperator2Options = this.ruleTemplateService.prepareOperatorOptions(
          selectedCondition.operators2,
          i,
          RulesAmountType.TAGS,
          this.currentAllConditionsSelectValue[j],
          this.currentOperator2Value[j],
        );

        this.currentOperator2Value[j][i] = updatedOrderTagsOperator2Options.find(
          (option: DropdownOption) => !option.disabled,
        );
        break;
      case 'totalOrderWeight':
        const updatedWeightOptions = this.ruleTemplateService.prepareOperatorOptions(
          selectedCondition.operators,
          i,
          RulesAmountType.WEIGHT,
          this.currentAllConditionsSelectValue[j],
          this.currentOperatorValue[j],
        );
        this.currentOperatorValue[j][i] = updatedWeightOptions.find((option: DropdownOption) => !option.disabled);
        updatedSelectedCondition.value = { operator: this.currentOperatorValue[j][i] };
        break;
      case 'totalOrderValue':
        const updatedValueOptions = this.ruleTemplateService.prepareOperatorOptions(
          selectedCondition.operators,
          i,
          RulesAmountType.TOTAL_VALUE,
          this.currentAllConditionsSelectValue[j],
          this.currentOperatorValue[j],
        );
        this.currentOperatorValue[j][i] = updatedValueOptions.find((option: DropdownOption) => !option.disabled);
        updatedSelectedCondition.value = { operator: this.currentOperatorValue[j][i] };
        break;
      case 'itemQuantity':
        const updatedItemsOptions = this.ruleTemplateService.prepareOperatorOptions(
          selectedCondition.operators,
          i,
          RulesAmountType.ITEM_QUANTITY,
          this.currentAllConditionsSelectValue[j],
          this.currentOperatorValue[j],
        );
        this.currentOperatorValue[j][i] = updatedItemsOptions.find((option: DropdownOption) => !option.disabled);
        updatedSelectedCondition.value = { operator: this.currentOperatorValue[j][i] };
        break;
      case 'inventoryLocation':
        const address = this.inventoryLocationOptions[0];
        this.currentInventoryLocationValue[j][i] = address;
        this.currentOperatorValue[j][i] = selectedCondition.operators[0];
        updatedSelectedCondition.value = { operator: this.currentOperatorValue[j][i], address };
        break;
      case 'boxChosen':
        const boxesArray = [];
        this.currentPackageValue[j][i] = boxesArray;
        this.currentOperatorValue[j][i] = selectedCondition.operators[0];
        updatedSelectedCondition.value = { operator: this.currentOperatorValue[j][i], boxesArray };
        break;
      case 'orderSku':
        const updatedOrderSkuOperatorOptions = this.ruleTemplateService.prepareOperatorOptions(
          selectedCondition.operators,
          i,
          RulesAmountType.SKUS,
          this.currentAllConditionsSelectValue[j],
          this.currentOperatorValue[j],
        );
        this.currentOperatorValue[j][i] = updatedOrderSkuOperatorOptions.find(
          (option: DropdownOption) => !option.disabled,
        );
        const updatedOrderSkusOperator2Options = this.ruleTemplateService.prepareOperatorOptions(
          selectedCondition.operators2,
          i,
          RulesAmountType.SKUS,
          this.currentAllConditionsSelectValue[j],
          this.currentOperator2Value[j],
        );

        this.currentOperator2Value[j][i] = updatedOrderSkusOperator2Options.find(
          (option: DropdownOption) => !option.disabled,
        );
        break;
      case 'orderStatusFix':
        const statusArray = [];
        this.currentStatusValue[j][i] = statusArray;
        updatedSelectedCondition.value = { statusArray };
        break;
      case RulesConditions.CreatedOn:
        this.currentCreatedOnValue[j][i] = {
          weekDays: [],
          from: this.timeOfDayOptions[0],
          to: this.timeOfDayOptions[this.timeOfDayOptions.length - 1],
          timezone: this.shopTimeZone,
        };
        updatedSelectedCondition.value = this.currentCreatedOnValue[j][i];
        break;
      case RulesConditions.Time:
        this.currentTimeWindowValue[j][i] = {
          weekDays: [],
          from: this.timeWindowOfDayOptions[0],
          to: this.timeWindowOfDayOptions[this.timeWindowOfDayOptions.length - 1],
          timezone: this.shopTimeZone,
        };
        this.currentOperatorValue[j][i] = selectedCondition.operators[0];
        updatedSelectedCondition.value = {
          operator: this.currentOperatorValue[j][i],
          ...this.currentTimeWindowValue[j][i],
        };
        break;
    }
    selectedCondition = updatedSelectedCondition;

    this.onChangeConditionSelect.emit({ value: selectedCondition, index: [j, i] });
    this.currentActionSelectValue = null;
    this.onResetActionSelectValue();
  }

  selectDeliveryMethod(selectedMethod, index): void {
    const [j, i] = index;

    if (!selectedMethod) {
      return;
    }
    const deliveryMethodsCondition = {
      ...this.currentAllConditionsSelectValue[j][i],
    };
    const is = this.currentOperatorValue[j][i].value === 'is';
    const operator = this.currentOperatorValue[j][i];
    const values = selectedMethod
      .filter((method) => method.checked)
      .map((method) => ({ value: method.value, label: method.label }));
    deliveryMethodsCondition.value = {
      operator,
      is,
      values,
    };
    this.currentDeliveryMethodsSelectValue[j][i] = values;
    this.onChangeConditionSelect.emit({ value: deliveryMethodsCondition, index });
  }

  onOrderTagConditionChanged(value, index) {
    const [j, i] = index;

    this.currentTagsValue[j][i] = value;
    const orderTagCondition = {
      ...this.currentAllConditionsSelectValue[j][i],
    };
    orderTagCondition.value = {
      value,
      operator: this.currentOperatorValue[j][i],
      operator2: this.currentOperator2Value[j][i],
    };

    this.onChangeConditionSelect.emit({ value: orderTagCondition, index });
  }

  onOrderSkuConditionChanged(value, index) {
    const [j, i] = index;
    this.currentSkusValue[j][i] = value;
    const orderCondition = {
      ...this.currentAllConditionsSelectValue[j][i],
    };
    orderCondition.value = {
      value,
      operator: this.currentOperatorValue[j][i],
      operator2: this.currentOperator2Value[j][i],
    };

    this.onChangeConditionSelect.emit({ value: orderCondition, index });
  }

  changeOperatorSelect(event, index) {
    const [j, i] = index;
    let operator;
    // here to prevent regression
    let is;
    if (event?.source?.controlType == 'mat-select') {
      if (event.value == 'is') {
        operator = { value: 'is', label: 'is' };
        is = true;
      }
      if (event.value == 'is-not') {
        operator = { value: 'is-not', label: 'is not' };
        is = false;
      }
    } else {
      operator = event;
    }

    this.currentSelectedDeliveryMethods[j][i] = [];
    this.currentSelectedDeliveryMethods = [...this.currentSelectedDeliveryMethods];

    if (this.currentDeliveryMethodInputValue[j]) {
      this.currentDeliveryMethodInputValue[j][i] = '';
    }

    this.currentOperatorValue[j][i] = operator;
    this.onChangeOperatorSelect.emit({ operator, is, index });
  }

  changeOperator2Select(event, index) {
    const [j, i] = index;
    let operator;
    // here to prevent regression
    let is;
    if (event?.source?.controlType == 'mat-select') {
      if (event.value == 'is') {
        operator = { value: 'is', label: 'is' };
        is = true;
      }
      if (event.value == 'is-not') {
        operator = { value: 'is-not', label: 'is not' };
        is = false;
      }
    } else {
      operator = event;
    }
    this.currentOperator2Value[j][i] = operator;

    this.onChangeOperator2Select.emit({ operator, is, index });
  }

  changeActionSelect({ value: selectedAction }): void {
    switch (selectedAction.name) {
      case RulesActions.TeamNote:
        this.currentActionSelectValue = selectedAction;
        this.onTeamNoteChanged(this.currentTeamNote);
        break;
      case RulesActions.SetRecommendedCarrier:
        this.carriersData = selectedAction.values;
        this.deliveryDateOptions = selectedAction.shipOnValues?.find((option) =>
          option.value.includes('Before'),
        )?.values;
      case RulesActions.SetWeightToSKU:
        this.initSearchTerm(null, FilterEntities.SKU, this.setWeightToSKUInputControl);
      default:
        // do not set for multiple values
        if (!selectedAction.values || selectedAction.values.length === 0) {
          this.onChangeActionSelect.emit(selectedAction);
        }
    }

    if (selectedAction.name === 'changeOrderStatusWithDelay') {
      this.setChangeOrderStatusWithDelayAction(this.currentDelayTime);
    }
    if (selectedAction.name == 'setInventoryLocation') this.currentLocationActionValue = null;
  }

  selectEmail({ value: selectedEmails }): void {
    const sendEmailAction = {
      ...this.currentActionSelectValue,
    };
    sendEmailAction.values = selectedEmails;
    this.onChangeActionSelect.emit(sendEmailAction);
  }

  selectCountry({ value: selectedCountries }, index): void {
    const [j, i] = index;

    if (!selectedCountries) {
      return;
    }
    const shippingAddressCountryCondition = {
      ...this.currentAllConditionsSelectValue[j][i],
    };
    const is = this.currentOperatorValue[j][i].value === 'is';
    const countries = selectedCountries;
    const operator = this.currentOperatorValue[j][i];
    shippingAddressCountryCondition.value = {
      operator,
      is,
      countries,
    };
    this.onChangeConditionSelect.emit({ value: shippingAddressCountryCondition, index });
  }

  selectState({ value: selectedStates }, index): void {
    const [j, i] = index;

    if (!selectedStates) {
      return;
    }
    const shippingAddressStateCondition = {
      ...this.currentAllConditionsSelectValue[j][i],
    };
    const states = selectedStates;
    const operator = this.currentOperatorValue[j][i];
    shippingAddressStateCondition.value = {
      operator,
      states,
    };
    this.onChangeConditionSelect.emit({ value: shippingAddressStateCondition, index });
  }

  onAmountTyped(amountTyped: number, index: any, type: RulesAmountType): void {
    const [j, i] = index;
    const amountCondition = this.ruleTemplateService.onAmountTyped(
      amountTyped,
      i,
      type,
      this.currentAllConditionsSelectValue[j],
      this.currentOperatorValue[j],
      this.currentWeightValue[j],
      this.currentItemQuantityValue[j],
      this.currentTotalValueVal[j],
    );
    this.onChangeConditionSelect.emit({ value: amountCondition, index });
  }

  changeInventorySelect(value, index): void {
    const [j, i] = index;

    const inventoryLocationCondition = this.ruleTemplateService.changeInventorySelect(
      value,
      i,
      this.currentAllConditionsSelectValue[j],
      this.currentOperatorValue[j],
    );
    this.onChangeConditionSelect.emit({ value: inventoryLocationCondition, index });
  }

  changePackageSelect(value, index): void {
    const [j, i] = index;

    const packageCondition = this.ruleTemplateService.changePackageSelect(
      value,
      i,
      this.currentAllConditionsSelectValue[j],
      this.currentOperatorValue[j],
      this.currentPackageValue[j],
    );
    this.onChangeConditionSelect.emit({ value: packageCondition, index });
  }

  changePaymentStatusSelect(value, index): void {
    const [j, i] = index;
    const paymentCondition = this.ruleTemplateService.changePaymentStatusSelect(
      value,
      i,
      this.currentAllConditionsSelectValue[j],
      this.currentOperatorValue[j],
      this.currentPaymentStatusValue[j],
    );
    this.onChangeConditionSelect.emit({ value: paymentCondition, index });
  }

  changeStatusSelect(statusSelected, index): void {
    const [j, i] = index;
    const statusCondtion: any = {
      ...this.currentAllConditionsSelectValue[j][i],
    };
    let statusArray = [...(this.currentStatusValue[j][i] ?? [])];
    if (statusSelected.checked) {
      statusArray.push(statusSelected);
    } else {
      statusArray = statusArray.filter((status) => status.value != statusSelected.value);
    }
    this.currentStatusValue[j][i] = statusArray;
    statusCondtion.value = {
      statusArray,
    };
    this.onChangeConditionSelect.emit({ value: statusCondtion, index });
    this.resetStatusVulnerableActions(statusArray);
  }

  checkIfActionDisabled(action: any, actionKey: number): boolean {
    // don't allow to set delete order action for if order verified condition:

    if (actionKey == 2 && this.currentAllConditionsSelectValue.length) {
      return this.currentAllConditionsSelectValue.some((conditionGroup) =>
        conditionGroup.some((currentConditionSelectValue) => currentConditionSelectValue?.value == 'stepNew'),
      );
    }
    if (action.value === 'stepPrint') {
      return !this.currentAllConditionsSelectValue.some((conditionGroup) =>
        conditionGroup.some(
          (currentConditionSelectValue) => currentConditionSelectValue?.name == 'fulfilledExternally',
        ),
      );
    }
    if (action.name === RulesActions.SplitOrder) {
      return !this.currentStatusValue?.some((statusesArray) => {
        return statusesArray?.some((statusArray) => {
          return statusArray?.length === 1 && statusArray?.some((status) => status?.value === OrderStatus.FIX_SPLIT);
        });
      });
    }
    if (action.name === RulesActions.SetWeightToSKU) {
      return !this.currentStatusValue?.some((statusesArray) => {
        return statusesArray?.some((statusArray) => {
          return statusArray?.some((status) => status?.value === OrderStatus.FIX_MEASURES);
        });
      });
    }
    if (action.name === RulesActions.SplitOrderByStrategy) {
      return this.currentStatusValue?.some((statusesArray) => {
        return statusesArray?.some((statusArray) => {
          return statusArray?.some((status) => status?.value === OrderStatus.FIX_SPLIT);
        });
      });
    }

    return action.disabled;
  }

  onTagSelect(index: any, tag: RulesTag) {
    const [j, i] = index;

    const { optionExists, tagsCondition } = this.ruleTemplateService.onTagSelect(
      i,
      tag,
      this.controls[j],
      this.currentAllConditionsSelectValue[j],
      this.currentSelectedTags[j],
      this.currentOperatorValue[j],
      this.currentOperator2Value[j],
    );
    if (!optionExists) {
      const currentTagInput = this.tagsInputs.find((tagInput: any) => tagInput.id == 'tagsInput' + index);
      currentTagInput?.input?.nativeElement?.focus();
      this.onChangeConditionSelect.emit({ value: tagsCondition, index });
    }
  }

  onTagRemove(conditionIndex: any, tagIndex: number): void {
    const j = conditionIndex[0];
    const i = conditionIndex[1];
    const tagsCondition = this.ruleTemplateService.onTagRemove(
      i,
      tagIndex,
      this.currentAllConditionsSelectValue[j],
      this.currentSelectedTags[j],
      this.currentOperatorValue[j],
      this.currentOperator2Value[j],
    );
    this.onChangeConditionSelect.emit({ value: tagsCondition, index: conditionIndex });
  }

  onDeliveryMethodSelect(index, method: string) {
    const [j, i] = index;

    const currentConditionsValue = this.currentAllConditionsSelectValue[j][i];
    this.controls[j][i].reset('', { onlySelf: true });
    this.currentSelectedDeliveryMethods[j][i] = Array.from(
      new Set([...this.currentSelectedDeliveryMethods[j][i], method]),
    );
    this.currentSelectedDeliveryMethods = [...this.currentSelectedDeliveryMethods];
    const newValues = this.currentSelectedDeliveryMethods[j][i].map((value) => ({ value, label: value }));

    this.onChangeConditionSelect.emit({
      value: {
        ...currentConditionsValue,
        value: { operator: this.currentOperatorValue[j][i], values: newValues },
      },
      index: index,
    });
  }

  onDeliveryMethodUnSelect(index, methodIndex) {
    const [j, i] = index;

    const currentMethods = [...(this.currentSelectedDeliveryMethods[j][i] || [])];
    currentMethods.splice(methodIndex, 1);
    this.currentSelectedDeliveryMethods[j][i] = [...currentMethods];
    this.currentSelectedDeliveryMethods = [...this.currentSelectedDeliveryMethods];
    const newValues = this.currentSelectedDeliveryMethods[j][i].map((value) => ({ value, label: value }));

    this.onChangeConditionSelect.emit({
      value: {
        ...this.currentAllConditionsSelectValue[j][i],
        value: {
          operator: this.currentOperatorValue[j][i],
          values: newValues,
        },
      },
      index: index,
    });
  }

  onSetWeightToSKUActionSelectSKU(sku: string) {
    this.setWeightToSKUInputControl.reset('', { onlySelf: true });
    this.onSetWeightToSKUChanged(null, sku);
  }

  onSkuSelect(index, sku: string) {
    const [j, i] = index;
    const { optionExists, skusCondition } = this.ruleTemplateService.onSkuSelect(
      i,
      sku,
      this.controls[j],
      this.currentAllConditionsSelectValue[j],
      this.currentSelectedSkus[j],
      this.currentOperatorValue[j],
      this.currentOperator2Value[j],
    );
    if (!optionExists) {
      const currentSkuInput = this.skusInputs.find((skuInput: any) => skuInput.id == 'skuInput' + i);
      currentSkuInput?.input?.nativeElement?.focus();
      this.onChangeConditionSelect.emit({ value: skusCondition, index });
    }
  }

  onSkuRemove(conditionIndex: number, skuIndex: number): void {
    const j = conditionIndex[0];
    const i = conditionIndex[1];
    const tagsCondition = this.ruleTemplateService.onSkuRemove(
      i,
      skuIndex,
      this.currentAllConditionsSelectValue[j],
      this.currentSelectedSkus[j],
      this.currentOperatorValue[j],
      this.currentOperator2Value[j],
    );
    this.onChangeConditionSelect.emit({ value: tagsCondition, index: conditionIndex });
  }

  onOrderCreatedWeekDayConditionChanged(value, index) {
    const [j, i] = index;
    const orderCondition = this.ruleTemplateService.changeCreateWeekDateSelect(
      value,
      i,
      this.currentAllConditionsSelectValue[j],
      this.currentCreatedOnValue[j],
    );
    this.onChangeConditionSelect.emit({ value: orderCondition, index });
  }

  onOrderCreatedTimeOfDayConditionChanged(value, index, type) {
    const [j, i] = index;
    const orderCondition = this.ruleTemplateService.changeCreateTimeOfDaySelect(
      value,
      type,
      i,
      this.timeOfDayOptions,
      this.currentAllConditionsSelectValue[j],
      this.currentCreatedOnValue[j],
    );
    this.onChangeConditionSelect.emit({ value: orderCondition, index });
  }

  onTimeWindowOfWeekDayConditionChanged(value, indices: [number, number]) {
    const [j, i] = indices;
    const timeCondition = this.ruleTemplateService.changeCreateWeekDateSelect(
      value,
      i,
      this.currentAllConditionsSelectValue[j],
      this.currentTimeWindowValue[j],
    );
    timeCondition.value.operator = this.currentOperatorValue[j][i];
    this.onChangeConditionSelect.emit({ value: timeCondition, index: [j, i] });
  }

  onTimeWindowOfDayConditionChanged(value, indices: [number, number], type) {
    const [j, i] = indices;
    const timeCondition = this.ruleTemplateService.changeCreateTimeOfDaySelect(
      value,
      type,
      i,
      this.timeWindowOfDayOptions,
      this.currentAllConditionsSelectValue[j],
      this.currentTimeWindowValue[j],
    );
    timeCondition.value.operator = this.currentOperatorValue[j][i];
    this.onChangeConditionSelect.emit({ value: timeCondition, index: [j, i] });
  }

  addOrCondition(index, shouldAddChildCondition = true): void {
    this.currentAllConditionsSelectValue.push([]);
    this.currentDeliveryMethodsSelectValue.push([]);
    this.currentTagsValue.push([]);
    this.currentSkusValue.push([]);
    this.currentCountrySelectValue.push([]);
    this.currentPaymentStatusValue.push([]);
    this.currentOperatorValue.push([]);
    this.currentOperator2Value.push([]);
    this.currentSelectedTags.push([]);
    this.currentSelectedSkus.push([]);
    this.currentWeightValue.push([]);
    this.currentItemQuantityValue.push([]);
    this.currentInventoryLocationValue.push([]);
    this.currentPackageValue.push([]);
    this.currentStatusValue.push([]);
    this.currentCreatedOnValue.push([]);
    this.currentCreatedOnValue.push([]);
    this.currentCreatedOnValue.push([]);
    this.currentStateSelectValue.push([]);
    this.currentTotalValueVal.push([]);
    this.currentSelectedDeliveryMethods.push([]);
    this.controls.push([]);
    this.packagesOptions.push([[]]);
    this.statusOptions.push([[]]);
    this.createdWeekDaysOptions.push([[]]);
    this.timeWindowWeekDaysOptions.push([[]]);
    this.deliveryMethodOptions.push([[]]);
    this.paymentStatusOptions.push([[]]);
    this.currentTimeWindowValue.push([]);
    if (shouldAddChildCondition) {
      this.addCondition([index, 0]);
    }
  }

  addCondition(index, shouldEmit = true): void {
    const [j, i] = index;
    this.currentSelectedDeliveryMethods[j].push([]);
    this.currentAllConditionsSelectValue[j].push(null);
    this.currentDeliveryMethodsSelectValue[j].push(null);
    this.currentTagsValue[j].push(null);
    this.currentSkusValue[j].push(null);
    this.currentCountrySelectValue[j].push(null);
    this.currentPaymentStatusValue[j].push([]);
    this.currentOperatorValue[j].push(null);
    this.currentSelectedTags[j].push([]);
    this.currentSelectedSkus[j].push([]);
    this.controls[j].push(new UntypedFormControl());
    this.initSearchTerm([j, i], FilterEntities.TAG);
    this.initSearchTerm([j, i], FilterEntities.SKU);
    this.initSearchTerm([j, i], FilterEntities.DELIVERY_METHOD);
    this.currentWeightValue[j].push(null);
    this.currentItemQuantityValue[j].push(null);
    this.currentInventoryLocationValue[j].push(null);
    this.currentPackageValue[j].push(null);
    this.currentStatusValue[j].push(null);

    this.currentCreatedOnValue[j].push({
      weekDays: [],
      from: this.timeOfDayOptions[0],
      to: this.timeOfDayOptions[this.timeOfDayOptions.length - 1],
      timezone: this.shopTimeZone,
    });

    this.currentTimeWindowValue[j].push({
      weekDays: [],
      from: this.timeWindowOfDayOptions[0],
      to: this.timeWindowOfDayOptions[this.timeWindowOfDayOptions.length - 1],
      timezone: this.shopTimeZone,
    });
    this.timeWindowWeekDaysOptions[j][i] = this.ruleTemplateService.initTimeWindowWeekDaysOptions(this.conditions);

    ((this.packagesOptions[j][i] = this.ruleTemplateService.initialPackagesOptions(
      this.ruleTemplateService,
      this.conditions,
    )),
      (this.createdWeekDaysOptions[j][i] = this.ruleTemplateService.initCreatedOnOptions(this.conditions)));

    this.statusOptions[j][i] = this.ruleTemplateService.convertValuesToDropDownOptions({
      labelField: 'label',
      valueField: 'value',
      typeField: 'type',
      values: RulesAutomationValidationStatuses,
      multiSelect: true,
    });

    this.deliveryMethodOptions[j][i] = this.ruleTemplateService.convertValuesToDropDownOptions({
      labelField: 'label',
      valueField: 'value',
      typeField: 'type',
      conditionName: 'deliveryMethod',
      conditions: this.conditions[0].values,
      multiSelect: true,
    });

    this.paymentStatusOptions[j][i] = this.ruleTemplateService.convertValuesToDropDownOptions({
      labelField: 'label',
      valueField: 'value',
      typeField: 'type',
      conditionName: 'paymentStatus',
      conditions: this.conditions[0].values,
      multiSelect: true,
    });

    if (shouldEmit) {
      this.indexOfLastMatOption = index;
      this.onChangeConditionSelect.emit({ value: {}, index });
    }
  }

  checkIfAllValuesInsertedForConditionGroup(row) {
    const isAllInserted = this.currentAllConditionsSelectValue[row]?.every((currentConditionSelectValue, index) => {
      return this.checkIfAllValuesInsertedForCurrentCondition(currentConditionSelectValue, row, index);
    });
    return isAllInserted;
  }
  checkIfAllValuesInsertedForCurrentCondition(currentConditionSelectValue, groupIndex, index) {
    switch (currentConditionSelectValue?.name) {
      case 'shippingAddressCountry':
        return !!this.currentCountrySelectValue[groupIndex]?.[index]?.length;
      case 'shippingAddressState':
        return !!this.currentStateSelectValue[groupIndex]?.[index]?.length;
      case 'deliveryMethod':
        return !!this.currentSelectedDeliveryMethods[groupIndex]?.[index]?.length && !!this.currentOperatorValue;
      case 'orderTag':
        return this.isAutoCompleteMode([groupIndex, index])
          ? !!this.currentSelectedTags[groupIndex]?.[index]?.length
          : !!this.currentTagsValue[groupIndex]?.[index];
      case 'totalOrderWeight':
        return !!this.currentWeightValue[groupIndex]?.[index];
      case 'totalOrderValue':
        return !!this.currentTotalValueVal[groupIndex]?.[index];
      case 'itemQuantity':
        return (
          !isNaN(this.currentItemQuantityValue[groupIndex][index]) &&
          this.currentItemQuantityValue[groupIndex][index] >= 0
        );
      case 'inventoryLocation':
        return !!this.currentInventoryLocationValue[groupIndex]?.[index];
      case 'boxChosen':
        return !!this.currentPackageValue[groupIndex]?.[index]?.length;
      case 'orderSku':
        return this.isAutoCompleteMode([groupIndex, index])
          ? !!this.currentSelectedSkus[groupIndex]?.[index]?.length
          : !!this.currentSkusValue[groupIndex]?.[index];
      case 'orderStatusFix':
        return !!this.currentStatusValue[groupIndex]?.[index]?.length;
      case 'paymentStatus':
        return !!this.currentPaymentStatusValue[groupIndex]?.[index]?.length;
      case RulesConditions.CreatedOn:
        return this.currentCreatedOnValue[groupIndex]?.[index];
    }
    return currentConditionSelectValue?.value;
  }
  checkIfAllValuesInserted() {
    const isAllInserted = this.currentAllConditionsSelectValue?.every((conditionGroup, groupIndex) => {
      return conditionGroup.every((currentConditionSelectValue, index) => {
        return this.checkIfAllValuesInsertedForCurrentCondition(currentConditionSelectValue, groupIndex, index);
      });
    });
    return isAllInserted;
  }

  removeCondition(index) {
    const [j, i] = index;

    this.currentAllConditionsSelectValue[j].splice(i, 1);
    this.currentDeliveryMethodsSelectValue[j].splice(i, 1);
    this.currentCountrySelectValue[j].splice(i, 1);
    this.currentSelectedTags[j].splice(i, 1);
    this.currentSelectedSkus[j].splice(i, 1);
    this.tagsControlsSubscriptions$[i]?.unsubscribe();
    this.skusControlsSubscriptions$[i]?.unsubscribe();
    this.controls[j].splice(i, 1);
    this.currentOperatorValue[j].splice(i, 1);
    this.currentWeightValue[j].splice(i, 1);
    this.currentItemQuantityValue[j].splice(i, 1);
    this.currentInventoryLocationValue[j].splice(i, 1);
    this.currentPackageValue[j].splice(i, 1);
    this.currentStatusValue[j].splice(i, 1);
    this.currentPaymentStatusValue[j].splice(i, 1);
    this.currentTagsValue[j].splice(i, 1);
    this.currentSkusValue[j].splice(i, 1);
    this.currentCreatedOnValue[j].splice(i, 1);
    this.currentSelectedDeliveryMethods[j].splice(i, 1);
    this.createdWeekDaysOptions[j].splice(i, 1);
    this.timeWindowWeekDaysOptions[j].splice(i, 1);
    if (j > 0 && i == 0 && this.currentAllConditionsSelectValue[j].length == 0) {
      this.currentAllConditionsSelectValue.splice(j, 1);
      this.currentDeliveryMethodsSelectValue.splice(j, 1);
      this.currentCountrySelectValue.splice(j, 1);
      this.currentSelectedTags.splice(j, 1);
      this.currentSelectedSkus.splice(j, 1);
      this.controls.splice(j, 1);
      this.currentSelectedDeliveryMethods.splice(j, 1);
      this.currentOperatorValue.splice(j, 1);
      this.currentWeightValue.splice(j, 1);
      this.currentItemQuantityValue.splice(j, 1);
      this.currentInventoryLocationValue.splice(j, 1);
      this.currentPackageValue.splice(j, 1);
      this.currentStatusValue.splice(j, 1);
      this.currentPaymentStatusValue.splice(j, 1);
      this.createdWeekDaysOptions.splice(j, i);
      this.timeWindowWeekDaysOptions.splice(j, i);
      this.currentTagsValue.splice(j, 1);
      this.currentSkusValue.splice(j, 1);
      this.currentCreatedOnValue.splice(j, 1);
    }
    this.onRemoveCondition.emit({ index });
  }

  getFormattedText(action: AutomationRulesActions.SelectedAction) {
    if (action.name === 'flagNotVerified') {
      return `${action.text} ${this.notVerifiedName}`;
    }
    return action.text.replace(/\[\[/g, '<span class="highlight">').replace(/\]\]/g, '</span>');
  }

  getActionText(action: AutomationRulesActions.SelectedAction) {
    let text = `<span class="value">${action.text}</span>`;

    switch (action.name) {
      case 'changeOrderStatusWithDelay':
        text = action.text.replace(' [[X]] minutes', '');
        break;
      case 'setRecommendedCarrier':
        text = action.text.replace('[[carrier]]', 'carrier');
        break;
      case 'addTeamNote':
        text = 'Add team note with the following message';
        break;
    }

    return text;
  }

  onResetActionSelectValue() {
    this.currentActionSelectValue = null;
    this.currentDeliveryServiceSelectValue = null;
    this.currentShippingDays = null;
    this.currentEmailSelectValue = null;
    this.currentDelayTime = null;
    this.notVerifiedName = this.verfiedNameToReset;
    this.currentSplitMethod = null;
    this.currentProductTagsSplitOperator = null;
    this.currentShipOnValue = {};
    this.currentActionTagsValue = [];
    this.currentSetWeightToSKUValue = { weight: null, sku: null };
    this.currentRecommendedCarrier = {};
    this.currentTeamNote = {};
    this.currentColorCoding = [ColorEnum.NO_COLOR];
    this.currentColorCodingOperator = this.colorCodingOptions[0];
    this.onChangeActionSelect.emit(this.currentActionSelectValue);
  }

  setNotVerifiedNameAction(notVerifiedName) {
    this.notVerifiedName = notVerifiedName;
    this.onChangeNotVerifiedName.emit(this.notVerifiedName);
  }

  setChangeOrderStatusWithDelayAction(delayTime: number): void {
    const changeOrderStatusWithDelayAction = {
      ...this.currentActionSelectValue,
    };
    changeOrderStatusWithDelayAction.value = { value: changeOrderStatusWithDelayAction.value, delayTime: +delayTime };
    this.onChangeActionSelect.emit(changeOrderStatusWithDelayAction);
  }

  onChangeLocationSelectedOrder(data: DropdownOption | number) {
    const selectedAction = {
      ...this.currentActionSelectValue,
    };
    selectedAction.value = data;
    this.onChangeActionSelect.emit(selectedAction);
  }

  onTeamNoteChanged(newValues) {
    const teamNoteAction = {
      ...this.currentActionSelectValue,
    };

    this.currentTeamNote = newValues;
    teamNoteAction.value = newValues;
    this.onChangeActionSelect.emit(teamNoteAction);
  }

  onShipmetExtrasChanged(newValues) {
    const shipmentExtrasAction = {
      ...this.currentActionSelectValue,
    };
    const valueToDisplay = Object.entries(newValues).map((entry) => {
      const valueFullObj = shipmentExtrasAction.values.find((v) => v.fieldName == entry[0]);
      const picked = (({ fieldName, displayName }) => ({ fieldName, displayName }))(valueFullObj) as any;
      picked.value = entry[1];
      return picked;
    });

    shipmentExtrasAction.value = { shipmentExtrasFields: newValues, valuesObj: valueToDisplay };
    this.onChangeActionSelect.emit(shipmentExtrasAction);
  }

  getProvidersDisplayName(providerName) {
    if (!providerName) {
      return;
    }
    return providerName[0]?.toUpperCase() + providerName.substr(1).toLowerCase();
  }

  getProviderServiceDisplayName(providerService) {
    if (!providerService) {
      return;
    }
    return ServiceLevelToDisplayName.get(providerService) ?? providerService;
  }

  setHeadsUpNotifications(action: any) {
    this.headsUp = this.ruleTemplateService.setHeadsUpNotifications(action, this.currentActionSelectValue);
  }

  onDeliveryMethodChanged(deliveryMethod: string): void {
    const changeDeliveryMethodAction = {
      ...this.currentActionSelectValue,
    };
    changeDeliveryMethodAction.value = deliveryMethod;
    this.onChangeActionSelect.emit(changeDeliveryMethodAction);
  }

  onSetWeightToSKUChanged(weight?: string, sku?: string) {
    if (weight) {
      const parsedWeight = Number(weight);
      this.currentSetWeightToSKUValue = {
        ...this.currentSetWeightToSKUValue,
        weight: isNaN(parsedWeight) ? null : parsedWeight,
      };
    }
    if (sku != null && sku != undefined) {
      this.currentSetWeightToSKUValue = {
        ...this.currentSetWeightToSKUValue,
        sku: sku,
      };
    }
    const setWeightToSKUAction = {
      ...this.currentActionSelectValue,
    };
    setWeightToSKUAction.value = this.currentSetWeightToSKUValue;

    this.onChangeActionSelect.emit(setWeightToSKUAction);
  }

  onColorCodingChanged(colors?: string[], operator?: DropdownOption): void {
    if (colors) {
      this.currentColorCoding = colors;
    }
    if (operator) {
      this.currentColorCodingOperator = operator;
    }
    const setColorCodingAction = {
      ...this.currentActionSelectValue,
    };
    setColorCodingAction.value = { colors: this.currentColorCoding, operator: this.currentColorCodingOperator };
    this.onChangeActionSelect.emit(setColorCodingAction);
  }

  isAutoCompleteMode(index) {
    const [j, i] = index;
    return ['includes', 'excludes'].includes(this.currentOperatorValue[j][i].value as string);
  }

  isDeliveryMethodAutoCompleteMode(index: [number, number]): boolean {
    const [j, i] = index;
    const operatorValue = this.currentOperatorValue[j][i]?.value;

    switch (operatorValue) {
      case 'is':
      case 'is-not':
        return true;
      case 'contains':
      case 'not-contains':
        return false;
      default:
        return false;
    }
  }

  resetStatusVulnerableActions(statusArray: DropdownOption[]) {
    if (this.currentActionSelectValue?.name === RulesActions.SplitOrder) {
      if (statusArray?.length !== 1 || (statusArray[0]?.value !== OrderStatus.FIX_SPLIT && statusArray[0]?.checked)) {
        this.onResetActionSelectValue();
      }
    }
    if (this.currentActionSelectValue?.name === RulesActions.SplitOrderByStrategy) {
      if (statusArray?.find((item) => item?.value === OrderStatus.FIX_SPLIT && item?.checked)) {
        this.onResetActionSelectValue();
      }
    }
  }

  onShipmentPreferencesChanged(newValues) {
    const recommendedCarrierAction = {
      ...this.currentActionSelectValue,
    };
    this.currentRecommendedCarrier = newValues;
    recommendedCarrierAction.value = {
      shipmentPreferncesFields: newValues,
      shipOn: this.currentShipOnValue,
    };
    this.onChangeActionSelect.emit(recommendedCarrierAction);
  }

  shipOnChanged(selectedValue: any) {
    const shipOnAction = {
      ...this.currentActionSelectValue,
    };
    this.currentShipOnValue = { ...selectedValue, shipOn: selectedValue.data };

    shipOnAction.value = {
      shipOn: this.currentShipOnValue,
      shipmentPreferncesFields: this.currentRecommendedCarrier,
    };
    this.onChangeActionSelect.emit(shipOnAction);
  }

  tagsChanged(tags: string[]) {
    const tagsAction = {
      ...this.currentActionSelectValue,
    };
    this.currentActionTagsValue = tags;

    tagsAction.value = tags;
    this.onChangeActionSelect.emit(tagsAction);
  }

  getDeliveryMethodInputValue(j: number, i: number): string {
    const values = this.currentSelectedDeliveryMethods[j]?.[i] || [];
    return values.join(', ');
  }

  isDuplicateDeliveryMethod(j: number, i: number): boolean {
    const currentInputValue = this.currentDeliveryMethodInputValue[j]?.[i]?.trim();
    if (!currentInputValue) return false;

    const currentValues = this.currentSelectedDeliveryMethods[j]?.[i] || [];
    return currentValues.includes(currentInputValue);
  }

  onDeliveryMethodInputChange(index: [number, number]): void {
    const [j, i] = index;
    const inputValue = this.currentDeliveryMethodInputValue[j][i];

    const deliveryMethods = inputValue
      .split(',')
      .map((method) => method.trim())
      .filter((method) => method.length > 0);

    this.currentSelectedDeliveryMethods[j][i] = deliveryMethods;
    this.currentSelectedDeliveryMethods = [...this.currentSelectedDeliveryMethods];

    const currentConditionsValue = this.currentAllConditionsSelectValue[j][i];
    const formattedValues = deliveryMethods.map((value) => ({ value, label: value }));

    this.onChangeConditionSelect.emit({
      value: {
        ...currentConditionsValue,
        value: { operator: this.currentOperatorValue[j][i], values: formattedValues },
      },
      index: index,
    });
  }

  getDeliveryMethodOperatorText(operator: string): string {
    return this.ruleTemplateService.getDeliveryMethodOperatorText(operator);
  }
}
